import APIService from "@/services/APIService.js";

const apiCargos = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/cargo"
});

export default {
  getAll(limit, page, filters) {
    return apiCargos.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nome",
        ...filters
      }
    });
  },
  update(id, cargo) {
    return apiCargos.put("/" + id, cargo);
  },
  create(cargo) {
    return apiCargos.post("", cargo);
  }
};
